<template id="ctFormUploadLogo">
	<div>
		<v-card >
			<div v-if="orgitem.logo !=''">
				<v-card-subtitle>{{ $t('lbl.currentLogo')}}</v-card-subtitle>
				
				<v-card-text>
					<v-img :src="orgitem.logo" max-height="150" max-width="300" position='left center' alt="Logo" contain></v-img>
				</v-card-text>
			</div>
	
			<v-card-subtitle>{{ $t('lbl.uploadLogo')}}</v-card-subtitle>

			<v-card-text>
				<v-form ref="logoFrm" v-model="valid" lazy-validation>
					<input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" >
					<v-layout row wrap>
						<v-flex xs12><v-text-field :label="$t('lbl.selectImage')" @click='pickFile' v-model='imageName' prepend-icon='attach_file' :rules="imageNameRules"></v-text-field></v-flex>
						<v-flex xs12><v-btn class="button-main" v-on:click="doUploadLogo()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.upload')}}</v-btn></v-flex>
					</v-layout>		
				</v-form>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
    data: () => ({
		valid: false,
		imageNameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		imageName: '',
		imageUrl: '',
		imageFile: ''
	}),
	props: ['orgitem'],
	methods: {
		pickFile () 
		{
            this.$refs.image.click ()
        },
		onFilePicked (e) 
		{
			const files = e.target.files
			if(files[0] !== undefined) 
			{
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) 
				{
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.imageFile = files[0] // this is an image file that can be sent to server...
				})
			} 
			else
			{
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
		},
		doUploadLogo() 
		{		
			try{
				if (this.$refs.logoFrm.validate()) 
				{
					this.$root.loading = true;
					
					var config = {headers: {'Content-Type': 'image/jpeg', 'Authorization': "bearer " +  this.getUserAccessToken()} };
					
					//console.log(config);
					//console.log("UPLOAD LOGO: " + constants.ENDPOINT_ORGANIZATION_UPLOADLOGO);	

					this.axios
						.put(constants.ENDPOINT_ORGANIZATION_UPLOADLOGO, this.imageFile, config)
						.then(response => {
							try{
								if(response.status == 200)
								{
									//console.log(response);
									if(!this.isEmptyString(response.data.url))
									{
										this.doUpdateLogoData(response.data.url);
										
									} 
									else 
									{
										this.$root.setDialogMsg(i18n.t('err.generic'));
									}
								} 
								else if(response.status == 401)
								{
									this.$root.tokenExpired();
								} 
								else 
								{
									this.$root.setDialogMsg(i18n.t('err.generic'));
								}
							} 
							finally 
							{ 
								this.$root.loading = false; 
							}								
						})
						.catch(error => { 
							this.$root.loading = false;  
							this.$root.catchGenericError(error); 
						});
				}
			} catch(error) { 
				this.$root.loading = false; 
				this.$root.catchGenericError(error); 
			}
		},
		doUpdateLogoData(url) 
		{
			if(!this.isEmptyString(this.orgitem.organization_id))
			{
				
				var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.orgitem.organization_id;
				var obj2send = {logo: url};

				this.$root.loading = true;
				
				this.axios
					.patch(endpoint2go, obj2send, this.getMyAuthHeader(this.getUser()) )
					.then(response => {
						try{
							if(response.status == 200)
							{		
								this.$root.setDialogMsg(i18n.t('msg.saveok'));

								//=== LANCIO EVENTO RICARICA ORGANIZZAZIONE
								events.$emit(constants.EVENT_DO_LOAD_ORG_DETAILS);

							} 
							else if(response.status == 401)
							{
								this.$root.tokenExpired();	
							} 
							else 
							{
								this.$root.setDialogMsg(i18n.t('err.generic'));
								
							}
						} 
						finally { 
							this.$root.loading = false; 
						}							
					})
					.catch(error => { 
						this.$root.loading = false; 
						this.$root.catchGenericError(error); 
					});
			} 
			else 
			{
				this.$root.loading = false;
				console.log("ORGANIZATION ID NOT VALID");
				this.$root.setDialogMsg(i18n.t('err.generic'));
			}	
		}
	}	
}
</script>